module.exports = __webpack_public_path__ + "img/vip0.7798724a.png";